<template>
  <div class="gaoya" v-if="!isShowDet">
    <div class="total">
      <div class="top">
        <div class="left">
          <div class="item">
            <span>回路总数：</span>
            <span class="color1">{{ equipmentNumber.totalCount }}</span>
          </div>
          <div class="item">
            <span>通讯正常：</span>
            <span class="color1">{{ equipmentNumber.normalCount }}</span>
          </div>
          <div class="item">
            <span>异常断开：</span>
            <span class="color3">{{ equipmentNumber.abnormalCount }}</span>
          </div>
          <div class="item">
            <span>离线：</span>
            <span class="color2">{{ equipmentNumber.offlineCount }}</span>
          </div>  
        </div>
        <div class="right">
          <el-input placeholder="请输入现场编号" prefix-icon="el-icon-search" clearable v-model="input2">
          </el-input>
          <el-button type="primary" @click="searchInfo">搜索</el-button>
        </div>
      </div>
      <div class="bottom">
        <div class="left">
          <div class="item" :class="stateIndex == item.type ? 'active' : ''" v-for="(item, index) in states" :key="index+'type'" @click="stateIndex = item.type">
            {{ item.title }}
          </div>
        </div>
        <div class="right">
          <span>开关状态：</span>
          <i class="color1"></i>
          <span>断开</span>
          <i class="color2"></i>
          <span>闭合</span>
        </div>
      </div>
    </div>
    <div class="main-info">
      <section v-for="(item, index) in equipmentList" :key="index">
        <i class="iconfont icon-sanjiao" :class="item.open ? '' : 'isClose'" @click="item.open = !item.open"></i>
        <div class="title" @click="item.open = !item.open">
          <div class="icon-box">
            <i class="iconfont icon-dian"></i>
          </div>
          <p>{{ item.cabinetNum }}</p>
        </div>
        <layout3 v-model="item.open">
          <div class="card-box">
            <div class="card" v-for="(item2, index2) in item.equipmentCabinetReals" :key="index2 + 'a'" @click="changeShowDet(item2)">
              <div class="top">
                <div class="ctitle">
                  <div class="left">
                    <img :src="getImgSrc(item2.equipmentStatus)" alt="" />
                    <!-- <img src="../../../assets/images/gaoya.png" alt="" /> -->
                    <p>{{ item2.localeNumber }}</p>
                  </div>
                  <div class="right">
                    <div class="circle-status" :class="item2.switchStatus.value==='0'?'circle-status0':'circle-status1'"></div>
                    <!-- <myswitch :type="item2.equipmentStatus"></myswitch> -->
                  </div>
                </div>
                <div class="info">
                  {{ item2.equipmentDesc }}
                </div>
              </div>
              <div class="br"></div>
              <div class="bottom">
                <div class="item">
                  <p>A相电流</p>
                  <p>{{ item2.currentList[0].value | getTwo}}（A）</p>
                </div>
                <div class="item">
                  <p>B相电流</p>
                  <p>{{ item2.currentList[1].value | getTwo}}（A）</p>
                </div>
                <div class="item">
                  <p>C相电流</p>
                  <p>{{ item2.currentList[2].value | getTwo}}（A）</p>
                </div>
              </div>
            </div>
          </div>
        </layout3>
      </section>
    </div>
  </div>
  <detail v-else :type="equipmentType" :code="equipmentCode"></detail>
</template>

<script>
  import detail from "./huiludet";
  import layout3 from "../../layout/layout3";
  import Layout3 from "../../layout/layout3.vue";
  // import myswitch from "../../unit/switch.vue";
  export default {
    components: {
      detail,
      Layout3,
      // myswitch,
    },
    data() {
      return {
        input2: "",
        states: [{
          title: "全部",
          type: null
        }, {
          title: "通讯正常",
          type: 1
        }, {
          title: "异常断开",
          type: 0
        }],
        stateIndex: null,
        equipmentType: 4,
        switchValue: true,
        equipmentNumber: {},
        equipmentList: [],
        equipmentCode: "",
      };
    },
    computed: {
      isShowDet() {
        return this.$store.state.isShowDet;
      },
      roomId() {
        return this.$store.state.roomId;
      },
    },
    watch: {
      roomId() {
        this.searchEquipmentStatusByType();
        this.searchLoopMonitors();
        this.stateIndex=null
      },
      stateIndex(n, o) {
        this.searchLoopMonitors(n);
      },
      input2(v) {
        if (!v) {
          this.searchEquipmentStatusByType();
          this.searchLoopMonitors();
          this.stateIndex=null
        }
      },
    },
    created() {
      this.searchEquipmentStatusByType();
      this.searchLoopMonitors();
      this.stateIndex=null
    },
    methods: {
      getImgSrc(i) {
        return require("../../../assets/images/gaoya" + i + ".svg");
      },
      changeShowDet(e) {
        if (e.equipmentTypeId == 2) {
          // this.$router.push("/all/bianyaqi");
          // this.$parent.monitorIndex = [2, 0];
          this.$router.push({
            path: "/all/bianyaqi",
            query: {
              type: '1'
            },
          })
        } else {
          this.$store.commit("setIsShowDet", true);
          this.equipmentCode = e.equipmentCode;
          this.$store.commit("setDetEquipmentCode", e.equipmentCode);
        }
      },
      searchInfo() {
        this.searchEquipmentStatusByType();
        this.searchLoopMonitors();
      },
      // 设备数量及状态统计
      searchEquipmentStatusByType() {
        // const roomId = this.$getCookie("roomId");
        if (!this.roomId) {
          return false;
        } else {
          this.$http
            .post(
              "bma-distribution-service/realTimeMonitoring/searchEquipmentStatusByHighLow", {
                roomId: this.roomId,
                type: 2
                // localeNumber: this.input2,
                // roomId: this.roomId,
              }
            )
            .then((res) => {
             
              this.equipmentNumber = res.data;
            });
        }
      },
      // 查询设备列表
      searchLoopMonitors(n) {
        let equipmentStatus;
          if (n == '1') {
          equipmentStatus = 0;
        } else if (n == '0') {
          equipmentStatus = 1;
        }else{
          equipmentStatus=null
        }
        // const roomId = this.$getCookie("roomId");
        if (!this.roomId) {
          return false;
        } else {
          this.$http
            .post("bma-distribution-service/realTime/searchLoopMonitors", {
              equipmentType: this.equipmentType,
              roomId: this.roomId,
              localeNumber: this.input2,
              equipmentStatus: equipmentStatus,
            })
            .then((res) => {
              if (res.data.length>0) {
                res.data.forEach((item) => {
                  item.open = true;
                  item.equipmentCabinetReals.forEach((item2) => {
                    item2.status = !!item2.equipmentStatus;
                  });
                });
                this.equipmentList = res.data;
              }else{
                 this.isShowDet=false
              }
            });
        }
      },
    },
  };
</script>

<style lang="less" scoped>
  .gaoya {
    margin-top: -15px;
    .total {
      width: 100%;
      background: #f8f8f9;
      box-shadow: 0px 0px 13px rgba(32, 47, 79, 0.09);
      padding: 20px;
      padding-bottom: 0;
      box-sizing: border-box;
      .top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .left {
          display: flex;
          .item {
            border: 1px solid #eaedef;
            border-radius: 21px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            padding: 0 27px;
            margin-right: 37px;
            span {
              font-weight: 600;
              &.color1 {
                color: rgba(20, 96, 224, 1);
              }
              &.color2 {
                color: rgba(224, 20, 20, 1);
              }
              &.color3 {
                color: #fd7f5a;
              }
            }
          }
        }
        .right {
          display: flex;
          .el-input {
            margin-right: 10px;
          }
        }
      }
      .bottom {
        margin-top: 30px;
        display: flex;
        align-items: baseline;
        justify-content: space-between;
        .left {
          display: flex;
          .item {
            margin-right: 30px;
            font-size: 16px;
            position: relative;
            padding-bottom: 15px;
            cursor: pointer;
            &.active {
              font-weight: 600;
              border-bottom: 3px solid rgba(20, 96, 224, 1);
            }
          }
        }
        .right {
          display: flex;
          align-items: center;
          font-size: 16px;
          color: #0e223d;
          i {
            width: 10px;
            height: 10px;
            border-radius: 50%;
            margin: 0 15px;
            &.color1 {
              background: rgba(61, 224, 159, 1);
            }
            &.color2 {
              background: rgba(248, 113, 113, 1);
            }
          }
        }
      }
    }
    .main-info {
      padding: 15px;
      box-sizing: border-box;
      max-height: 600px;
      overflow-y: scroll;
      section {
        position: relative;
      }
      .icon-sanjiao {
        position: absolute;
        top: 30px;
        right: 25px;
        cursor: pointer;
        color: #0e223d;
        font-size: 10px;
        transition: 0.3s all;
        transform-origin: center;
        transform: scale(0.6);
        &.isClose {
          transform-origin: center;
          transform: rotateZ(-90deg);
        }
      }
      .title {
        display: inline-block;
        padding: 9px 18px;
        background: #fff;
        border-radius: 7px;
        line-height: 26px;
        height: 40px;
        font-size: 16px;
        background: #ffffff;
        box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.07);
        margin-bottom: 15px;
        cursor: pointer;
        box-sizing: border-box;
        .icon-box {
          width: 15px;
          height: 15px;
          background: rgba(20, 96, 224, 1);
          text-align: center;
          line-height: 15px;
          margin-right: 5px;
          display: inline-block;
          i {
            color: #fff;
          }
        }
        p {
          font-weight: 600;
          display: inline-block;
        }
      }
      .circle-status {
        width: 12px;
        height: 12px;
        border-radius: 50%;
      }
      .circle-status0 {
        background: linear-gradient(180deg, #3ecf97 0%, #81e2bc 100%);
      }
      .circle-status1 {
        background: linear-gradient(180deg, #f87171 0%, #f5abab 100%);
      }
      .card-box {
        display: flex;
        flex-wrap: wrap;
        cursor: pointer;
        .card {
          width: 387px;
          height: 218px;
          background: #ffffff;
          box-shadow: 0px 3px 6px rgba(40, 76, 122, 0.1);
          opacity: 1;
          border-radius: 8px;
          margin-right: 15px;
          margin-bottom: 15px;
          &:nth-of-type(4n) {
            margin-right: 0;
          }
          .top {
            padding: 9px 20px;
            border-bottom: 1px solid #e9e9e9;
            .ctitle {
              display: flex;
              align-items: center;
              justify-content: space-between;
              .left {
                display: flex;
                align-items: center;
                cursor: pointer;
                img {
                  width: 40px;
                  margin: 16px 7px 12px 0px;
                }
                p {
                  font-weight: 600;
                }
              }
            }
            .info {
              color: #7d7d7d;
              line-height: 18px;
              min-height: 54px;
              font-size: 14px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 3;
              -webkit-box-orient: vertical;
            }
          }
          .br {
            width: 104px;
            height: 1px;
            background: #1460e0;
            margin-top: -1px;
          }
          .bottom {
            display: flex;
            .item {
              width: 33.33%;
              text-align: center;
              p {
                color: #0e223d;
                font-size: 14px;
                font-weight: 600;
                &:first-of-type {
                  line-height: 3;
                  font-weight: 400;
                }
              }
              span {
                color: #0e223d;
                font-size: 14px;
                font-weight: 600;
              }
            }
          }
        }
      }
    }
  }
</style>